<template>
  <div v-if="banner" class="ss-banner ui-banner ui-banner--lg" role="alert">
    <v-icon size="18">mdi-alert-outline</v-icon>
    <div>
      <b>{{ banner.title }}</b>
      <span>{{ banner.text }}</span>
    </div>
    <button type="button" class="ui-btn ui-btn--sm" @click="ctl.save()">{{ $t("report_mobile.retry") }}</button>
    <button type="button" class="ui-icon-btn ui-icon-btn--plain ui-icon-btn--sm" :aria-label="$t('close')" @click="ctl.ui.banner = null">
      <v-icon size="16">mdi-close</v-icon>
    </button>
  </div>
</template>

<script>
/** Greška pri snimanju: izmjene ostaju na ekranu, a "Pokušaj ponovo" šalje isti zahtjev. */
export default {
  name: "SetBanner",
  inject: { ctl: "settingsCtl" },
  computed: {
    banner() {
      return this.ctl.ui.banner;
    },
  },
};
</script>
